/** Deutsche Labels der Schweregrade — eine Quelle für Erfassen und Anzeigen einer Meldung. */
import type { DamageSeverity } from '@/shared/api';

export const DAMAGE_SEVERITY_LABEL: Record<DamageSeverity, string> = {
  Minor: 'Gering',
  Major: 'Mittel',
  Critical: 'Kritisch',
};
